/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancellableReservation
 */
export interface CancellableReservation {
    /**
     * 
     * @type {string}
     * @memberof CancellableReservation
     */
    localEndTime: string;
    /**
     * 
     * @type {string}
     * @memberof CancellableReservation
     */
    localStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof CancellableReservation
     */
    reservationId: string;
}

/**
 * Check if a given object implements the CancellableReservation interface.
 */
export function instanceOfCancellableReservation(value: object): value is CancellableReservation {
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('reservationId' in value) || value['reservationId'] === undefined) return false;
    return true;
}

export function CancellableReservationFromJSON(json: any): CancellableReservation {
    return CancellableReservationFromJSONTyped(json, false);
}

export function CancellableReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellableReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'reservationId': json['reservationId'],
    };
}

export function CancellableReservationToJSON(value?: CancellableReservation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'reservationId': value['reservationId'],
    };
}

